module.exports = __webpack_public_path__ + "media/images/icons/social-google-763fae5cdea96860944cf28c4a940140.svg";